import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { CreditsService } from 'src/@core/services/credits/credits.service';
import { NotificationService } from 'src/@core/services/notification.service';

@Component({
  selector: 'hour4u-admin-withdraw',
  templateUrl: './withdraw.component.html',
  styleUrls: ['./withdraw.component.scss']
})
export class WithdrawComponent implements OnInit {
  withdrawalForm: FormGroup;
  paymentMethods: any[] = [
    {
      name: 'UPI',
      type: 'UPI'
    },
    {
      name: 'Bank account',
      type: 'BANK_TRANSFER'
    }
  ];
  step: number = 1;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '0',
  };
  otp: string = "";
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  isEditBankAccount: boolean = false;
  selectedBankDetails: any = null;

  constructor(
    public dialogRef: MatDialogRef<WithdrawComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedData: any,
    private _fb: FormBuilder,
    private appService: AppService,
    public creditsService: CreditsService,
    private notify: NotificationService
  ) { }

  ngOnInit() {
    this.withdrawalForm = this._fb.group({
      availableAmountForWithdraw: [null, [Validators.required]],
      wantAmountForWithdraw: ["", [Validators.required]],
      paymentMode: ["BANK_TRANSFER"],
      accountNumber: [""],
      confirmAccountNumber: [""],
      ifscCode: [""],
      accountHolderName: [""],
      upiId: [""],
      check: [false],
      remarks: [""]
    })
    if (this.selectedData && this.selectedData.walletBalance) {
      this.withdrawalForm.controls['availableAmountForWithdraw'].setValue(this.selectedData.walletBalance);
      this.withdrawalForm.controls['availableAmountForWithdraw'].updateValueAndValidity();
    }

    if (this.selectedData && this.selectedData.step) {
      this.step = this.selectedData.step;
      this.withdrawalForm.get('availableAmountForWithdraw').clearValidators();
      this.withdrawalForm.get('wantAmountForWithdraw').clearValidators();
      this.withdrawalForm.get('accountNumber').clearValidators();
      this.withdrawalForm.get('confirmAccountNumber').clearValidators();
      this.withdrawalForm.get('ifscCode').clearValidators();
      this.withdrawalForm.get('accountHolderName').clearValidators();
      this.withdrawalForm.get('upiId').clearValidators();
    }
  }

  // get saved Bank Account Details
  getBankAccountDetails() {
    this.isLoading = true;
    this.creditsService.fetchBankAccountDetailsList(this.profile.entity.id).subscribe(res => {
      console.log(res)
      this.isLoading = false;
      this.step++;
      if (res && res.length) {
        this.selectedBankDetails = res[0];
        this.isEditBankAccount = true;
        this.withdrawalForm.controls['paymentMode'].setValue(this.selectedBankDetails.payMode);
        if (this.selectedBankDetails.payMode == "BANK_TRANSFER") {
          this.withdrawalForm.controls['accountNumber'].setValidators([Validators.required]);
          this.withdrawalForm.controls['confirmAccountNumber'].setValidators([Validators.required]);
          this.withdrawalForm.controls['ifscCode'].setValidators([Validators.required]);
          this.withdrawalForm.controls['accountHolderName'].setValidators([Validators.required]);
          this.withdrawalForm.controls['upiId'].setValidators([]);
          this.withdrawalForm.controls['accountNumber'].setValue(this.selectedBankDetails.bankAccountNumber);
          this.withdrawalForm.controls['confirmAccountNumber'].setValue(this.selectedBankDetails.bankAccountNumber);
          this.withdrawalForm.controls['ifscCode'].setValue(this.selectedBankDetails.ifscCode);
          this.withdrawalForm.controls['accountHolderName'].setValue(this.selectedBankDetails.nameOnAccount);
        }

        if (this.selectedBankDetails.payMode == "UPI") {
          this.withdrawalForm.controls['accountNumber'].setValidators([]);
          this.withdrawalForm.controls['confirmAccountNumber'].setValidators([]);
          this.withdrawalForm.controls['ifscCode'].setValidators([]);
          this.withdrawalForm.controls['accountHolderName'].setValidators([]);
          this.withdrawalForm.controls['upiId'].setValidators([Validators.required]);
          this.withdrawalForm.controls['upiId'].setValue(this.selectedBankDetails.upiId);
        }
        this.withdrawalForm.controls['accountNumber'].updateValueAndValidity();
        this.withdrawalForm.controls['confirmAccountNumber'].updateValueAndValidity();
        this.withdrawalForm.controls['ifscCode'].updateValueAndValidity();
        this.withdrawalForm.controls['accountHolderName'].updateValueAndValidity();
        this.withdrawalForm.controls['upiId'].updateValueAndValidity();
        this.withdrawalForm.controls['check'].setValidators([Validators.required]);
        this.withdrawalForm.controls['check'].updateValueAndValidity();
      }
    }, ((err: any) => {
      this.isEditBankAccount = false;
      this.isLoading = false;
      this.selectedBankDetails = null;
    }))
  }

  // change Payment Mode
  changePaymentMethod() {
    this.isEditBankAccount = false;
    this.selectedBankDetails = null;
    if (this.withdrawalForm.controls['paymentMode'].value === 'UPI') {
      this.withdrawalForm.controls['accountNumber'].setValidators([]);
      this.withdrawalForm.controls['confirmAccountNumber'].setValidators([]);
      this.withdrawalForm.controls['ifscCode'].setValidators([]);
      this.withdrawalForm.controls['accountHolderName'].setValidators([]);
      this.withdrawalForm.controls['upiId'].setValidators([Validators.required]);
      this.withdrawalForm.controls['upiId'].setValue("");
    }
    if (this.withdrawalForm.controls['paymentMode'].value === 'BANK_TRANSFER') {
      this.withdrawalForm.controls['accountNumber'].setValidators([Validators.required]);
      this.withdrawalForm.controls['confirmAccountNumber'].setValidators([Validators.required]);
      this.withdrawalForm.controls['ifscCode'].setValidators([Validators.required]);
      this.withdrawalForm.controls['accountHolderName'].setValidators([Validators.required]);
      this.withdrawalForm.controls['upiId'].setValidators([]);
      this.withdrawalForm.controls['accountNumber'].setValue("");
      this.withdrawalForm.controls['confirmAccountNumber'].setValue("");
      this.withdrawalForm.controls['ifscCode'].setValue("");
      this.withdrawalForm.controls['accountHolderName'].setValue("");
    }
    this.withdrawalForm.controls['check'].setValidators([Validators.required]);
    this.withdrawalForm.controls['check'].updateValueAndValidity();
    this.withdrawalForm.controls['accountNumber'].updateValueAndValidity();
    this.withdrawalForm.controls['confirmAccountNumber'].updateValueAndValidity();
    this.withdrawalForm.controls['ifscCode'].updateValueAndValidity();
    this.withdrawalForm.controls['accountHolderName'].updateValueAndValidity();
    this.withdrawalForm.controls['upiId'].updateValueAndValidity();
  }

  disable() {
    let disableNext = false;
    if (this.step == 1) {
      if (!this.withdrawalForm.controls['availableAmountForWithdraw'].value ||
        !this.withdrawalForm.controls['wantAmountForWithdraw'].value) {
        disableNext = true;
      } else {
        if (this.withdrawalForm.controls['wantAmountForWithdraw'].value > this.withdrawalForm.controls['availableAmountForWithdraw'].value) {
          disableNext = true;
        } else {
          disableNext = false;
        }
      }
    }

    if (this.step == 2) {
      if (this.withdrawalForm.controls['check'].value == false || this.withdrawalForm.controls['check'].value == 'false') {
        disableNext = true;
      }

      if (this.withdrawalForm.controls['accountNumber'].value != this.withdrawalForm.controls['confirmAccountNumber'].value) {
        disableNext = true;
      }
    }

    if (this.step == 3) {
      if (this.otp && this.otp.length == 6) {
        disableNext = false;
      } else {
        disableNext = true;
      }
    }

    if (this.isLoading) {
      disableNext = true;
    }
    return disableNext;
  }

  next() {
    this.isLoading = true;
    if (this.withdrawalForm.controls.wantAmountForWithdraw.value < 1) {
      this.notify.showMessage("Withdrawal amount should be greater than 1 and less than or equal to withdrawlable amount", 5000);
      this.isLoading = false;
      return;
    }
    if (!this.withdrawalForm.valid) {
      this.isLoading = false;
      this.withdrawalForm.markAllAsTouched();
      return;
    } else {
      if (this.step == 1) {
        this.getBankAccountDetails();
      }

      if (this.step == 2) {
        this.isLoading = true;
        let obj = {
          "entityId": this.profile.entity.id,
          "payMode": this.withdrawalForm.controls['paymentMode'].value,
          "bankAccountNumber": this.withdrawalForm.controls['accountNumber'].value,
          "ifsc": this.withdrawalForm.controls['ifscCode'].value,
          "name": this.withdrawalForm.controls['accountHolderName'].value,
          "upiId": this.withdrawalForm.controls['upiId'].value,
        }
        console.log(this.isEditBankAccount, this.selectedBankDetails, obj)
        if (this.isEditBankAccount) {
          if (this.selectedBankDetails && this.selectedBankDetails.bankAccountId) {
            this.creditsService.updateBankAccountDetails(this.selectedBankDetails.bankAccountId, obj).subscribe(res => {
              this.verifyOTPSent();
            }, ((err: any) => {
              this.isLoading = false;
            }))
          } else {
            this.isLoading = false;
          }
        } else {
          this.creditsService.addBankAccountDetails(obj).subscribe(res => {
            this.selectedBankDetails = res;
            this.notify.showMessage("Bank account details added!", 2000);
            this.verifyOTPSent();
          }, ((err: any) => {
            this.isLoading = false;
          }))
        }
      }

      if (this.step == 3) {
        if (this.selectedData.step && this.selectedData.step == 3) {
          this.dialogRef.close(this.otp);
        } else {
          this.fundTransferToAccount();
        }
      }
    }
  }

  verifyOTPSent() {
    let obj = {
      "bankAccountId": this.selectedBankDetails.bankAccountId,
      "entityId": this.profile.entity.id,
      "amount": this.withdrawalForm.controls['wantAmountForWithdraw'].value,
      "payoutInitiatorId": this.profile.user.id
    }
    this.creditsService.paymentVerifyOTPSend(obj).subscribe(res => {
      this.notify.showMessage("OTP sent to loggedin user's email", 2000);
      this.isLoading = false;
      this.step++;
    }, ((err: any) => {
      this.isLoading = false;
    }))
  }

  fundTransferToAccount() {
    let obj = {
      "userId": this.profile.entity.id,
      "bankAccountId": this.selectedBankDetails.bankAccountId,
      "amount": this.withdrawalForm.controls['wantAmountForWithdraw'].value,
      "otp": this.otp,
      "remarks": this.withdrawalForm.controls['remarks'].value,
      "payoutInitiatorId": this.profile.user.id
    }
    this.isLoading = true;
    this.creditsService.fundTransfterWalletToBankAccount(obj).subscribe(res => {
      this.isLoading = false;
      this.notify.showMessage("Amount will receive to your bank account soon...", 2000);
      this.dialogRef.close(true);
    }, ((err: any) => {
      this.isLoading = false;
    }))
  }

  onOtpChange(event: any) {
    this.otp = event;
  }

  onBackPress() {
    this.step = this.step - 1;
  }
}
